import { Component, OnInit } from '@angular/core';
import { CustomizerService } from './services/customizer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';

  constructor(public customizer: CustomizerService,) {

  }
  ngOnInit(): void {

  }
}
